import clsx from "clsx";
import React from "react";
import css from "./container.module.scss";

export interface ContainerProps extends React.ComponentProps<"div">
{
    horizontalGap?: number;
    stretch?: boolean;
    verticalGap?: number;
    itemsCentered?: boolean;
    justifyCenter?: boolean;
    hiddenOnMobile?: boolean;
    hiddenOnDesktop?: boolean;
}

export const Container = ({ className, horizontalGap, itemsCentered, justifyCenter, stretch, style, verticalGap: vertialGap, hiddenOnMobile = false, hiddenOnDesktop = false, ...props }: ContainerProps): React.ReactComponentElement<"div", ContainerProps> =>
{
    const styles: React.CSSProperties = {
        ...style,
        ["--horizontal-gap" as any]: horizontalGap !== undefined ? `${horizontalGap}px` : "0px",
        ["--vertical-gap" as any]: vertialGap !== undefined ? `${vertialGap}px` : "0px",
    }

    const classNames = clsx(
        css["container"],
        {
            "stretch": stretch === true,
            [css["items-centered"]]: itemsCentered,
            [css["justify-center"]]: justifyCenter,
            [css["hidden-on-mobile"]]: hiddenOnMobile,
            [css["hidden-on-desktop"]]: hiddenOnDesktop,
        },
        className
    );

    return <div {...props} className={classNames} style={styles} />;
}